import ProgressBarWithProgressiveFraction from "app/components/React/Table/cells/ProgressBarWithProgressiveFraction";
import { StyledAdNetworkProgressBarWrapper } from "./styles";

interface Props {
    value: number | null;
}

const AdNetworkProgressBarContainer = ({ value }: Props) => {
    return (
        <StyledAdNetworkProgressBarWrapper>
            <ProgressBarWithProgressiveFraction value={value} />
        </StyledAdNetworkProgressBarWrapper>
    );
}

export default AdNetworkProgressBarContainer;
